import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import { message } from 'antd';
import PhaserLibrarianGame from 'src/games/LibrarianGame/Main';

interface LibrarianGameProps extends PageProps<{}> {
    onComplete?: () => void;
}

class LibrarianGame extends React.Component<LibrarianGameProps> {
    constructor(props: LibrarianGameProps) {
        super(props);
        bindAllOfThis(this, LibrarianGame.prototype);
    }

    completeGame() {
        return message.success("You finished the game!");
    }

    render() {
        return <div>
            <PhaserLibrarianGame onComplete={this.completeGame}/>
        </div>;
    }
}

export default LibrarianGame;



// WEBPACK FOOTER //
// ./src/pages/game/LibrarianGame.tsx